

import Vue from 'vue';
import $ from 'jquery';
import { Component, Prop } from 'vue-property-decorator';
import { ref, onMounted } from 'vue';
import { AiSearchClient, SearchRequest, AiPromptsClient, MediaApiControllerUIClient, EmailServiceRequest } from '../backend/backendapi';
import { initClient } from '../../api';

declare var window: WindowType;

@Component({
})
export default class AskModal extends Vue {
@Prop({ required: true })
jobId!: string;
@Prop({ required: true })
jobRequestMode!: boolean;

private readonly api = initClient(AiSearchClient);
private readonly promptApi = initClient(AiPromptsClient);
private readonly mediaApi = initClient(MediaApiControllerUIClient);
private mediaUrls = {};

showJobAsk = false;
tags = ref<string[]>([]);
selectedTags = ref<string[]>([]);
quicks:string[] = ["nodata"];

prompt = ref<string>('');
response= ref<string>();
sources = ref<Array<SearchSources>>([]);
error= ref<string>()
loading: ref<boolean> = false;
mode = ref<'replace' | 'append'>('append');
topK = ref<number>(2);
baseApi: string= "";

getPlaceholder(): string {
  return this.$t('ai.ask.placeholder') as string;
}

open(): void
{
   $(this.$refs.aimodal!).modal('show');
}

close(): void
{
   $(this.$refs.aimodal!).modal('hide');
   this.$nextTick(() => {      
    $(this.$refs.aimodal!).modal('hide');
  })
}

async loadTags(): Promise<void> {
  try {
      await this.promptApi.getTags().then( res => {
      const data = (res) as string[];
      this.tags = Array.isArray(data) ? data : [];
    }).catch( err => {
      throw new Error(`Failed to load tags: ${err}`);
    });
  } catch (err) {
    this.tags.value = ['overview', 'usage', 'security', 'performance'];
  }
  if(this.tags.length > 0)
  {
      this.selectedTags.push(this.tags[0]);
  }
}

toggleTag(t: string) {
  const idx = this.selectedTags.indexOf(t);
  this.clearTags();
  if (idx === -1) this.selectedTags.push(t);
  else this.selectedTags.splice(idx, 1);
}

clearTags() {
  this.selectedTags = [];
}

async loadQuicks(): Promise<void> {
  try {
      this.promptApi.getPrompts().then( res => {
      const data = (res) as string[];
      this.quicks = Array.isArray(data) ? data : [];
    }).catch( err => {
      throw new Error(`Failed to load quicks: ${err}`);
    });
  } catch (err) {
    this.quicks= [ this.$t('ai.quicks.default1'),this.$t('ai.quicks.default2'),this.$t('ai.quicks.default3')];
  }
}

public useQuick(q: string) {
  if (this.mode === 'replace') {
    this.prompt = q;
  } else {
    if (this.prompt && !this.prompt.endsWith(' ') && !this.prompt.endsWith('\n')) {
      this.prompt += ' ';
    }
    this.prompt += q;
  }
}

clearAll():function {
  this.prompt = '';
  this.response = '';
  this.error = '';
}

async submit(): Promise<void> {
    this.error = '';
    this.response = '';
    this.sources = [];

    if (!this.prompt.trim()) {
      this.error = String(this.$t('ai.prompt.error'));
      return;
    }

    this.loading = true;
    try {
      if (this.showJobAsk) {
        const req = new EmailServiceRequest({
          query: this.prompt,
          topK: this.topK,
          tags: this.selectedTags,
          jobId: this.jobId || ''
        });

        const result = await this.api.answerJobFacts(req);
        // Parse the full HTML string
        const parser = new DOMParser();
        const doc = parser.parseFromString(result?.answer ?? '', 'text/html');
        this.response = doc.body.innerHTML;      // Extract just the inner HTML of the body (un-escapes entities automatically)

        //this.response = result?.answer ?? '';
        this.sources = result?.sources ?? [];
      } else {
        const result = await this.api.search(new SearchRequest({
          query: this.prompt,
          tags: this.selectedTags,
          topK: this.topK
        }));

        this.response = result?.answer ?? '';
        this.sources = result?.sources ?? [];

        for (const s of this.sources) {
          s.publicUrl = '';
          if (!s.mediaId || s.mediaId === '00000000-0000-0000-0000-000000000000') continue;
          const media = await this.mediaApi.get(s.mediaId);
          s.publicUrl = media.publicUrl;
        }
      }
    } catch (err: any) {
      this.error = err?.message ?? String(err);
    } finally {
      this.loading = false;
    }
  }

async copyPrompt(): Promise<void> {
  if (!this.prompt) return;
  try {
    await navigator.clipboard.writeText(this.prompt);
    this.response = this.$t('ai.prompt.copied');;
    setTimeout(() => {
      if (this.response === 'Prompt copied to clipboard.') this.response = '';
    }, 1200);
  } catch (err) {
    this.error = 'Unable to copy to clipboard.';
  }
}

 async mounted(): Promise<void> {
    this.baseApi=window.application.baseUrl;
    await this.loadQuicks();
    await this.loadTags();
   }
}

